import BaseModel from '../core/BaseModel'
export default class HistoryNiemYetModel extends BaseModel {

    constructor() {
        super({ 
                name: "history_niemyet",
                tableName: 'history_niemyet', 
                label: "Danh Sách Lịch sử niêm yết", 
                display_key: 'id', 
                default_order: { key: 'id', direction: 'asc' } }, 
            {
            stt: {
                name: "stt",
                label: "STT",
                type: "Computed",
                computed: (data, index) => {
                    data.stt = index + 1;
                },
            },
            id: { 
                name: 'id', 
                type: "Int", 
                label: 'ID', 
                primaryKey: true, 
                display: false
            },
            object: { 
                name: 'object', 
                type: "Int", 
                label: 'Đối tượng', 
                display: false
            },
            date_sent: { 
                name: 'date_sent', 
                type: "Date", 
                label: "Ngày gửi", 
                display: false
            },
            date_appointment: { 
                name: 'date_appointment', 
                type: "Date", 
                label: 'Ngày hẹn lại', 
                display: false
            },
            status: { 
                name: 'status', 
                type: "Int", 
                label: 'Trạng thái', 
                display: false
            },
            personal: { 
                name: 'personal', 
                type: "String", 
                label: 'Nhập tên hoặc sdt tư pháp', 
                display: false
            },
            reason: { 
                name: 'reason', 
                type: "String", 
                label: 'Lý do', 
                display: false
            },
            note: { 
                name: 'note', 
                type: "String", 
                label: 'Ghi chú', 
                display: false
            },
        },)
    }

}